module.exports = NavigationDirective;

function NavigationDirective() {
    return {
        'templateUrl': require('./views/navigation.html')
    }
}
